import { SxProps } from "@mui/material"
import { Theme } from "@mui/system"

export const actionsCheckbox: SxProps<Theme> = {
  padding: "0",
  color: "var(--Schemes-On-Surface-Variant)",
  svg: {
    width: "24px",
    height: "24px",
  },
  "&.Mui-checked": {
    color: "var(--Schemes-Primary)",
  },
}
